import { Difficulty } from '../enums/course.enum'

/** Labels de difficulté pour l'affichage */
export const DIFFICULTY_LABELS: Record<number, { label: string; color: string; emoji: string }> = {
  [Difficulty.DISCOVERY]: { label: 'Découverte', color: '#22c55e', emoji: '🌱' },
  [Difficulty.BEGINNER]: { label: 'Débutant', color: '#3b82f6', emoji: '📘' },
  [Difficulty.INTERMEDIATE]: { label: 'Intermédiaire', color: '#f59e0b', emoji: '⚡' },
  [Difficulty.ADVANCED]: { label: 'Avancé', color: '#ef4444', emoji: '🔥' },
  [Difficulty.EXPERT]: { label: 'Expert', color: '#7c3aed', emoji: '🧠' },
}

/** Catalogue NeuroForge Academy (structure de référence, order 0 → 13) */
export const INITIAL_COURSE_STRUCTURE = [
  {
    order: 0,
    title: 'Utiliser NeuroForge Academy',
    difficulty: Difficulty.DISCOVERY,
    tags: ['onboarding', 'plateforme', 'catalogue', 'guide'],
  },
  {
    order: 1,
    title: "01 — Les bases : Comprendre & utiliser l'IA",
    difficulty: Difficulty.DISCOVERY,
    tags: ['fondamentaux', 'ia', 'débutant'],
  },
  {
    order: 2,
    title: "02 — Générer & retoucher des images avec l'IA",
    difficulty: Difficulty.DISCOVERY,
    tags: ['images', 'génération', 'grand public'],
  },
  {
    order: 3,
    title: "03 — Créer & modifier de la musique avec l'IA",
    difficulty: Difficulty.DISCOVERY,
    tags: ['musique', 'audio', 'suno'],
  },
  {
    order: 4,
    title: "04 — Montage vidéo avec l'IA",
    difficulty: Difficulty.DISCOVERY,
    tags: ['vidéo', 'montage', 'grand public'],
  },
  {
    order: 5,
    title: "05 — Voix & audio avec l'IA",
    difficulty: Difficulty.DISCOVERY,
    tags: ['voix', 'tts', 'audio'],
  },
  {
    order: 6,
    title: "06 — Présentations & visuels avec l'IA",
    difficulty: Difficulty.DISCOVERY,
    tags: ['présentations', 'visuels', 'gamma'],
  },
  {
    order: 7,
    title: "07 — Rechercher & s'informer avec l'IA",
    difficulty: Difficulty.DISCOVERY,
    tags: ['recherche', 'veille', 'perplexity'],
  },
  {
    order: 8,
    title: "08 — L'IA au quotidien",
    difficulty: Difficulty.DISCOVERY,
    tags: ['quotidien', 'productivité', 'grand public'],
  },
  {
    order: 9,
    title: 'Prompt Engineering — Fondamentaux',
    difficulty: Difficulty.BEGINNER,
    tags: ['prompting', 'techniques', 'bonnes pratiques'],
  },
  {
    order: 10,
    title: 'FORGE AI Headroom — Assistant LLM local',
    difficulty: Difficulty.INTERMEDIATE,
    tags: ['headroom', 'llm', 'outillage'],
  },
  {
    order: 11,
    title: "Architecture d'Agents IA",
    difficulty: Difficulty.ADVANCED,
    tags: ['agents', 'architecture', 'avancé'],
  },
  {
    order: 12,
    title: 'RAG — Retrieval Augmented Generation',
    difficulty: Difficulty.ADVANCED,
    tags: ['rag', 'embeddings', 'vector'],
  },
  {
    order: 13,
    title: 'Notion AI & Automatisation',
    difficulty: Difficulty.INTERMEDIATE,
    tags: ['notion', 'automatisation', 'workflows'],
  },
] as const
